export function money(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

export function ram(mb: number): string {
  return mb >= 1024 ? `${mb / 1024} GB` : `${mb} MB`;
}

export function bytes(n: number | null): string {
  if (!n) return "—";
  const units = ["B", "KB", "MB", "GB"];
  let v = n;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(1)} ${units[i]}`;
}

export function date(s: string | null): string {
  if (!s) return "—";
  return new Date(s).toLocaleString();
}
